// loading/slice.js

import { loadingInitialState } from "./loadingState";
import { makeLoadingActions } from "./loadingActions";

export const createLoadingSlice = (set, get) => ({
  loading: loadingInitialState,
  loadingActions: Object.freeze(makeLoadingActions(set, get)),
});
